"use strict";

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PrerenderingHelper =
/*#__PURE__*/
function () {
  function PrerenderingHelper() {
    _classCallCheck(this, PrerenderingHelper);
  }

  _createClass(PrerenderingHelper, null, [{
    key: "init",

    /**
     * Registers some "hooks" that will enable Prerendering with emotion-based theming
     * Does nothing if not in a Prerendering session (by checking the user agent)
     */
    value: function init() {
      var _this = this;

      if (window.navigator.userAgent.includes("Prerender")) {
        // @ts-ignore
        window.prerenderReady = false;
        setTimeout(function () {
          setInterval(function () {
            _this.prerenderAllowed = true; // @ts-ignore

            if (_this.importantComponents.size === 0 && !window.prerenderReady) {
              console.log("Info: Allowing Prerender Now! (interval)");

              _this.onNextFrameSetPrerenderReady();
            }
          }, 1000); // check regularly
        }, 3000);
        setTimeout(function () {
          // @ts-ignore
          if (!window.prerenderReady) {
            console.log("Info: Allowing Prerender Now! (timeout)");

            _this.onNextFrameSetPrerenderReady();
          }
        }, 15000); // timeout after 15 sec (20 is env max, we need to stay lower)
      }
    }
    /**
     * Registers a heavy component, that shall be waited for
     * @param key React-Component to be waited for
     */

  }, {
    key: "waitFor",
    value: function waitFor(key) {
      this.importantComponents.add(key);
    }
    /**
     * Unregisters a heavy component, since it will be rendered by the next frame
     * @param key React-Component that should not be waited for anymore
     */

  }, {
    key: "onNextFrameDone",
    value: function onNextFrameDone(key) {
      this.importantComponents.delete(key);

      if (this.importantComponents.size === 0 && this.prerenderAllowed && // @ts-ignore
      !window.prerenderReady) {
        console.log("Info: Allowing Prerender Now! (done)");
        this.onNextFrameSetPrerenderReady();
      }
    }
    /**
     * Do what has to be done for Prerendering and notify Prerendering with a global flag
     */

  }, {
    key: "onNextFrameSetPrerenderReady",
    value: function onNextFrameSetPrerenderReady() {
      PrerenderingHelper.extractCSStoHTML(); // @ts-ignore

      this.onNextFrame(function () {
        return window.prerenderReady = true;
      });
    }
    /**
     * Register a callback on the next frame
     * @param callback
     */

  }, {
    key: "onNextFrame",
    value: function onNextFrame(callback) {
      // special version for special react rendering
      setTimeout(function () {
        return window.requestAnimationFrame(callback);
      }, 1);
    }
  }]);

  return PrerenderingHelper;
}();

exports.default = PrerenderingHelper;
PrerenderingHelper.prerenderAllowed = false;
PrerenderingHelper.importantComponents = new Set();
/**
 * Extracts css-rules from the document stylesheets
 * and adds it to the a style tag inside of the head
 * Motivation: Prerendering doesn't work with the css rules hidden in styleSheets
 */

PrerenderingHelper.extractCSStoHTML = function () {
  var flatReducer = function flatReducer(flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? toFlatten.reduce(flatReducer, []) : toFlatten);
  };

  var cssStyles = Array.from(document.styleSheets || []).map(function (x) {
    return Array.from(x.cssRules || []);
  }).reduce(flatReducer, []).map(function (x) {
    return x.cssText || "";
  }).join(" ");
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  head.appendChild(style);
  style.id = "prerender-styles";
  style.appendChild(document.createTextNode(cssStyles));
};